import FormSelect from "./FormSelect"
const statesOptions = [
    { "label": "Alabama", "value": "AL" },
    { "label": "Alaska", "value": "AK" },
    { "label": "Arizona", "value": "AZ" },
    { "label": "Arkansas", "value": "AR" },
    { "label": "California", "value": "CA" },
    { "label": "Colorado", "value": "CO" },
    { "label": "Connecticut", "value": "CT" },
    { "label": "Delaware", "value": "DE" },
    { "label": "Florida", "value": "FL" },
    { "label": "Georgia", "value": "GA" },
    { "label": "Hawaii", "value": "HI" },
    { "label": "Idaho", "value": "ID" },
    { "label": "Illinois", "value": "IL" },
    { "label": "Indiana", "value": "IN" },
    { "label": "Iowa", "value": "IA" },
    { "label": "Kansas", "value": "KS" },
    { "label": "Kentucky", "value": "KY" },
    { "label": "Louisiana", "value": "LA" },
    { "label": "Maine", "value": "ME" },
    { "label": "Maryland", "value": "MD" },
    { "label": "Massachusetts", "value": "MA" },
    { "label": "Michigan", "value": "MI" },
    { "label": "Minnesota", "value": "MN" },
    { "label": "Mississippi", "value": "MS" },
    { "label": "Missouri", "value": "MO" },
    { "label": "Montana", "value": "MT" },
    { "label": "Nebraska", "value": "NE" },
    { "label": "Nevada", "value": "NV" },
    { "label": "New Hampshire", "value": "NH" },
    { "label": "New Jersey", "value": "NJ" },
    { "label": "New Mexico", "value": "NM" },
    { "label": "New York", "value": "NY" },
    { "label": "North Carolina", "value": "NC" },
    { "label": "North Dakota", "value": "ND" },
    { "label": "Ohio", "value": "OH" },
    { "label": "Oklahoma", "value": "OK" },
    { "label": "Oregon", "value": "OR" },
    { "label": "Pennsylvania", "value": "PA" },
    { "label": "Rhode Island", "value": "RI" },
    { "label": "South Carolina", "value": "SC" },
    { "label": "South Dakota", "value": "SD" },
    { "label": "Tennessee", "value": "TN" },
    { "label": "Texas", "value": "TX" },
    { "label": "Utah", "value": "UT" },
    { "label": "Vermont", "value": "VT" },
    { "label": "Virginia", "value": "VA" },
    { "label": "Washington", "value": "WA" },
    { "label": "West Virginia", "value": "WV" },
    { "label": "Wisconsin", "value": "WI" },
    { "label": "Wyoming", "value": "WY" }
]
const FormAddress = ({ register, errors, style, baseName, disabled, control, excludes = [] }) => {
    return (
        <>
            <div className="form-input" style={style}>
                <label>{'Address1'}</label>

                <input {...register(`${baseName}.address1`)} type={'text'} style={{ height: "48px" }} placeholder={'address1'} disabled={disabled} />

                {errors[`${baseName}.address1`] && <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{errors[`${baseName}.address1`]?.message}</p>}
            </div>

            <div style={{ display: 'flex', gap: '1rem' }}>
                <div className="form-input" style={style}>
                    <label>{'Address2'}</label>

                    <input {...register(`${baseName}.address2`)} type={'text'} style={{ height: "48px" }} placeholder={'address2'} disabled={disabled} />

                    {errors[`${baseName}.address2`] && <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{errors[`${baseName}.address2`]?.message}</p>}
                </div>

                <div className="form-input" style={style}>
                    <label>{'Address3'}</label>

                    <input {...register(`${baseName}.address3`)} type={'text'} style={{ height: "48px" }} placeholder={'address3'} disabled={disabled} />

                    {errors[`${baseName}.address3`] && <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{errors[`${baseName}.address3`]?.message}</p>}
                </div>

            </div>

            <div style={{ display: 'flex', gap: '1rem' }}>
                <div className="form-input" style={style}>
                    <label>{'City'}</label>

                    <input {...register(`${baseName}.city`)} type={'text'} style={{ height: "48px" }} placeholder={'city'} disabled={disabled} />

                    {errors[`${baseName}.city`] && <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{errors[`${baseName}.city`]?.message}</p>}
                </div>

                <FormSelect
                    label={'State'}
                    name={`${baseName}.state`}
                    control={control}
                    options={statesOptions}
                    errors={errors}
                    placeholder="Select..."
                />

                {/* postal code is duplicated for formating */}
                {(excludes.includes('county') && excludes.includes('country')) && <div className="form-input" style={style}>
                    <label>{'Postal code'}</label>

                    <input {...register(`${baseName}.postalCode`)} type={'number'} style={{ height: "48px" }} placeholder={'postal code'} disabled={disabled} />

                    {errors[`${baseName}.postalCode`] && <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{errors[`${baseName}.postalCode`]?.message}</p>}
                </div>}

            </div>

            <div style={{ display: 'flex', gap: '1rem' }}>

                {!excludes.includes('county') && <div className="form-input" style={style}>
                    <label>{'County'}</label>

                    <input {...register(`${baseName}.county`)} type={'text'} style={{ height: "48px" }} placeholder={'county'} disabled={disabled} />

                    {errors[`${baseName}.county`] && <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{errors[`${baseName}.county`]?.message}</p>}
                </div>}

                {/* postal code is duplicated for formating */}
                {!(excludes.includes('county') && excludes.includes('country')) && <div className="form-input" style={style}>
                    <label>{'Postal code'}</label>

                    <input {...register(`${baseName}.postalCode`)} type={'number'} style={{ height: "48px" }} placeholder={'postal code'} disabled={disabled} />

                    {errors[`${baseName}.postalCode`] && <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{errors[`${baseName}.postalCode`]?.message}</p>}
                </div>}


                {!excludes.includes('country') && <FormSelect
                    label={'Country'}
                    name={`${baseName}.country`}
                    control={control}
                    options={[{ value: 'UNITED STATES', label: 'US' }]}
                    errors={errors}
                    placeholder="Select..."
                />}


            </div>



        </>

    )
}

export default FormAddress